import cn from 'classnames';

import ContentArea from 'components/content-area/ContentArea';
import Heading from 'components/heading/Heading';
import RichText from 'components/rich-text/RichText';
import OptionsModal from 'components/options-modal/OptionsModal';

import { ITextWithSidebar } from 'source/NFR.types';

interface TextWithSidebarProps extends ITextWithSidebar {
  isOpen?: boolean;
  isProposalPage?: boolean;
}

const TextWithSidebar: React.FC<TextWithSidebarProps> = ({
  headingLevel = 2,
  sidebar,
  text,
  title,
  htmlId,
  share,
  isOpen = true,
  isProposalPage = false
}) => (
  <div
    className={cn('text-with-sidebar', {
      '-is-proposal-page': isProposalPage
    })}
  >
    <div className="text-with-sidebar--top-line" />
    <div className="text-with-sidebar--content">
      {share && isOpen && (
        <div className="text-with-sidebar--links">
          <OptionsModal theme="isTextWithSidebar" {...share}></OptionsModal>
        </div>
      )}
      {title && (
        <Heading id={htmlId} className="text-with-sidebar--title" level={headingLevel}>
          {title}
        </Heading>
      )}
      <RichText {...text} />
    </div>
    {sidebar && (
      <div className="text-with-sidebar--sidebar">
        <ContentArea {...sidebar} />
      </div>
    )}
  </div>
);

TextWithSidebar.displayName = 'TextWithSidebar';

export default TextWithSidebar;
